import { normalizeApiError } from '../../../utils/normalizeApiError';
import axiosInstance from '../../axiosInstance';
import { API_URLS } from '../../url';
import { ConvertToScrumCheck, ConvertToScrumResult } from '../../../types/pmo/convertToScrum';

/** Read-only: what the conversion would move, for the screen to show first. */
export const getConvertToScrumCheck = async (
  projectUuid: string,
): Promise<ConvertToScrumCheck> => {
  try {
    const { data } = await axiosInstance.get<{ response: ConvertToScrumCheck }>(
      API_URLS.PMO_CONVERT_TO_SCRUM_CHECK(projectUuid),
    );
    return data.response;
  } catch (error) {
    throw normalizeApiError(error);
  }
};

/** One-way: open items move to the Backlog, done items stay as they are. */
export const convertToScrum = async (projectUuid: string): Promise<ConvertToScrumResult> => {
  try {
    const { data } = await axiosInstance.post<{ response: ConvertToScrumResult }>(
      API_URLS.PMO_CONVERT_TO_SCRUM(projectUuid),
    );
    return data.response;
  } catch (error) {
    throw normalizeApiError(error);
  }
};
